{
  "nav": {
    "mainNavigation": "Main navigation",
    "sectionSettings": "Settings",
    "settings": "Settings",
    "users": "Users",
    "groups": "Groups",
    "changeBranch": "Change Branch",
    "systems": "Systems",
    "toggleSidebarHint": "Toggle navigation",
    "deposits": "Deposits",
    "newDeposit": "New deposit",
    "deliver": "Deliver a deposit",
    "reports": "Reports",
    "currencies": "Currencies",
    "depositSettings": "Deposit settings",
    "reportHeld": "Held deposits",
    "reportDelivered": "Delivered deposits",
    "reportDetailed": "Detailed statement",
    "reportByCustomer": "By customer",
    "reportByEmployee": "By employee"
  },
  "sidebar": {
    "toggle": "Toggle Sidebar",
    "toggleHint": "Show or hide the menu",
    "title": "Sidebar",
    "description": "Navigate between the system pages"
  },
  "brand": "Al-Musafer"
}
